export default function IconOutdoorGyms() {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      aria-hidden="true"
    >
      {/* eslint-disable-next-line max-len */}
      <path d="M26.79,28.11s.76,6.36.64,8-1,22.78-1,22.78l3.37.12L32,41.87,34.17,59l3.43-.12S36.3,39,36.09,36a47.3,47.3,0,0,1,.79-7.88L50,13.62,46.67,13,34.81,25.49,29,25.43,17.33,13.15,14,13.77Z" />
      <circle cx="32" cy="20" r="4" />
      <rect x="5" y="5" width="6" height="54" />
      <rect x="53" y="5" width="6" height="54" />
      <rect x="8" y="10" width="48" height="4" />
    </svg>
  );
}
